import React from 'react';

interface IconProps {
  size?: number;
  className?: string;
  ariaHidden?: boolean;
  ariaLabel?: string;
}

const IconInventory: React.FC<IconProps> = ({
  size = 19,
  className,
  ariaHidden = true,
  ariaLabel,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 19 19"
    fill="none"
    className={className}
    aria-hidden={ariaHidden ? true : undefined}
    aria-label={ariaLabel}
  >
    <path d="M4.82504 18L2.19017 18C1.7676 18 1.42505 17.6574 1.42505 17.2348V5.79337C1.42505 5.20202 1.76578 4.66359 2.30021 4.41044L8.84496 1.3103C9.25959 1.11389 9.74047 1.11389 10.1551 1.3103L16.6999 4.41044C17.2343 4.66359 17.575 5.20202 17.575 5.79337V17.2348C17.575 17.6574 17.2325 18 16.8099 18L14.175 18" stroke="currentColor" strokeWidth="1.14768"/>
    <path d="M4.82471 18.0001V11.1152C4.82471 10.6927 5.16726 10.3501 5.58983 10.3501H13.4096C13.8321 10.3501 14.1747 10.6927 14.1747 11.1152V18.0001" stroke="currentColor" strokeWidth="1.14768" strokeLinecap="round"/>
    <path d="M5.25 15.45L13.75 15.45" stroke="currentColor" strokeWidth="1.14768" strokeLinecap="round"/>
    <path d="M5.25 12.8999L13.75 12.8999" stroke="currentColor" strokeWidth="1.14768" strokeLinecap="round"/>
  </svg>
);

export default IconInventory;
